module.exports = __webpack_public_path__ + "static/img/10.4bd0983a.png";